import {FC} from "react";

export const StopIcon: FC = () => {
    return (
        <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M4 0.5H2C0.89543 0.5 0 1.39543 0 2.5V18.5C0 19.6046 0.895431 20.5 2 20.5H4C5.10457 20.5 6 19.6046 6 18.5V2.5C6 1.39543 5.10457 0.5 4 0.5Z" fill="#909090"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M14 0.5H12C10.8954 0.5 10 1.39543 10 2.5V18.5C10 19.6046 10.8954 20.5 12 20.5H14C15.1046 20.5 16 19.6046 16 18.5V2.5C16 1.39543 15.1046 0.5 14 0.5Z" fill="#909090"/>
        </svg>
    )
}import {FC} from "react";

export const StopIcon: FC = () => {
    return (
        <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M4 0.5H2C0.89543 0.5 0 1.39543 0 2.5V18.5C0 19.6046 0.895431 20.5 2 20.5H4C5.10457 20.5 6 19.6046 6 18.5V2.5C6 1.39543 5.10457 0.5 4 0.5Z" fill="#909090"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M14 0.5H12C10.8954 0.5 10 1.39543 10 2.5V18.5C10 19.6046 10.8954 20.5 12 20.5H14C15.1046 20.5 16 19.6046 16 18.5V2.5C16 1.39543 15.1046 0.5 14 0.5Z" fill="#909090"/>
        </svg>
    )
}